import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { useContext, useEffect, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const WallToolSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const [zoom, setZoom] = useState<number>(ctxEdit.mapRef?.current?.getZoom() ?? 10);

    useEffect(() => {
        const map = ctxEdit.mapRef?.current?.getMap();

        function onZoom() {
            setZoom(map.getZoom());
        }

        map?.on('zoom', onZoom);

        return () => {
            map?.off('zoom', onZoom);
        };
    }, [ctxEdit.mapRef]);

    return (
        <motion.div {...ANIMATION_APPEAR}>
            <S_WallToolSidebar className={props.className}>
                <SidebarContent withTopPadding>
                    {zoom <= 17 && (
                        <S_Message type="warning">{Localization.ZOOM_IN_MORE}</S_Message>
                    )}
                </SidebarContent>
            </S_WallToolSidebar>
        </motion.div>
    );
};

const S_WallToolSidebar = styled.div`
    width: 100%;
`;

const S_Message = styled(Message)`
    margin: 0 0 15px 0;
`;
